module.exports = __webpack_public_path__ + "img/l6.ca40cee2.png";